import { kBiContentMaxWidth } from '@euler/app/flows/bi-dashboards/components/ui/BiPageHeader';
import {
  kBiStackedBelow,
  kBiThreeColumnsFrom,
} from '@euler/app/flows/bi-dashboards/functions/biGridLayout';

/** The screen a page is previewed at. */
export enum BiGalleryWidth {
  Phone = 'phone',
  Pad = 'pad',
  Desktop = 'desktop',
}

export const kBiGalleryWidths: Record<
  BiGalleryWidth,
  { label: string; px: number }
> = {
  [BiGalleryWidth.Phone]: { label: '手机 390', px: 390 },
  [BiGalleryWidth.Pad]: { label: 'iPad 834', px: 834 },
  [BiGalleryWidth.Desktop]: { label: '桌面', px: kBiContentMaxWidth },
};

/** Cards per row at a preview width, as a dashboard lays them out. */
export function biGalleryColumnCount(width: number): number {
  if (width >= kBiThreeColumnsFrom) return 3;
  return width >= kBiStackedBelow ? 2 : 1;
}
